import { withI18n } from 'panda-i18n';
import { CnDialogFullpage as CnDialogFullpageView } from './fullpage';
import locale from '@/locale';
import './index.scss';
const CnDialogFullpage = withI18n(CnDialogFullpageView, {
    locale,
    _noHoc: true,
});
CnDialogFullpage.displayName = 'CnDialogFullpage';
export { CnDialogFullpage };
